import {UserMenuItem} from '@models/sidebar/response/user-menu-item';
import {MenuItemType} from '@models/sidebar/menu-item-type';
import {PageItem} from '@models/sidebar/page-item';

export class NodeRequest {
  id: string | null = null;
  name: string = '';
  machineId: string | null = null;
  firebaseUserId: string = '';
  index: number = -1;
  shared: boolean = false;
  type: MenuItemType = MenuItemType.NODE;

  constructor(userMenuItem: UserMenuItem | PageItem) {
    this.id = userMenuItem.id;
    this.name = userMenuItem.name;
    this.machineId = userMenuItem.machineId;
    if (userMenuItem.firebaseUserId) {
      this.firebaseUserId = userMenuItem.firebaseUserId;
    }
    this.index = userMenuItem.index;
    this.type = userMenuItem.type;
  }
}
